import {
	Component,
	ChangeDetectorRef,
	OnInit,
	AfterViewInit,
	AfterViewChecked,
	AfterContentChecked,
	OnDestroy,
	Input,
	ViewChild
} from '@angular/core';
import { CreativesCoxV5Component } from '../creatives-cox-v5/creatives-cox-v5.component';
import { AnalyticsService } from '../../../analytics/services/analytics.service';
import { AnalyticsDataModel } from '../../../analytics/models/analytics.datamodel';
import { ColorUtilityService } from '../../../analytics-core/services/color.utility.service';
import { ColorPalette } from '../../../analytics-core/interfaces/partner.interface';
import * as moment from 'moment';
import * as _ from 'underscore';
import * as jQuery from 'jquery';
import * as numeral from 'numeral';
import { ModalService } from '../../../shared/directives/modal/modal.service';
import { PATHS } from '../../../analytics/constants/analytics.constants';
import { CreativeAdSize, CreativePerformance } from '../creative-detail-v2/creative-detail.interface';
import { UtilityService } from '../../../../core/utility/services/utility.service';

@Component({
	selector: 'app-sem-creative-cox-v5',
	templateUrl: '../creatives-cox-v5/creatives-cox-v5.component.html',
	styleUrls: ['../creatives-cox-v5/creatives-cox-v5.component.css']
})
export class SemCreativeCoxV5Component
	extends CreativesCoxV5Component
	implements OnInit, AfterViewInit, AfterViewChecked, AfterContentChecked, OnDestroy
{
	public colorPalette: ColorPalette;
	public colorArray: any;
	@Input() sectiontitle: string;
	@Input() sectionclass: string;
	@Input() sortdataby: any;
	@Input() nodatamessage: string;
	@Input() placeholderimage: any;
	@Input() secondarykey: string;
	public isOverviewSem: boolean;
	public playBtn;
	public playTxt;
	public pauseBtn;
	public pauseTxt;
	@ViewChild('videoName') videoplayer: any;
	@Input() barchartconfiguration;
	public isMuted = false;
	public barChartDataConfiguration: any;
	primaryColor: string;
	public socialCreative: boolean = false;
	defaultColor: string;
	public selectedCreative;
	public isEntravisionR103: boolean = false;

	constructor(
		protected analyticsService: AnalyticsService,
		protected colorUtilityService: ColorUtilityService,
		protected analyticsDataModel: AnalyticsDataModel,
		protected cdr: ChangeDetectorRef,
		protected modalService: ModalService
	) {
		super(analyticsService, colorUtilityService, analyticsDataModel, cdr, modalService);
	}

	ngOnInit() {
		super.ngOnInit();
		this.barChartDataConfiguration = JSON.parse(decodeURI(this.barchartconfiguration));
		this.primaryColor = this.colorPalette.primaryColor;
		this.defaultColor = 'white';
		this.badgeClass = 'ovrw_badge_display';
		this.arrowClass = 'overview_left_arrow';
		this.arrowRightClass = 'overview_right_arrow';
		this.overviewTitle = true;
		this.colorPalette = this.analyticsDataModel.partner.colorPalette;
		this.colorArray = Object.values(this.colorPalette);
		this.playBtn = this.sectionclass + 'playBtn';
		this.playTxt = this.sectionclass + 'playTxt';
		this.pauseBtn = this.sectionclass + 'pauseBtn';
		this.pauseTxt = this.sectionclass + 'pauseTxt';
		if (!this.nodatamessage || this.nodatamessage === 'undefined') {
			this.nodatamessage = 'No Data to Display';
		}
		this.isOverviewSem = this.sectiontitle.indexOf('SEM') !== -1;
		this.isEntravisionR103 =
			this.analyticsDataModel.config.directoryName.toLowerCase() === 'entravision-r103' ? true : false;
	}

	openModal(id: string, creative: any) {
		if (!this.selectedCreative) {
			this.selectedCreative = creative;
		}
		setTimeout(() => {
			this.modalService.open(id);
		}, 200);
	}

	closeModal(id: string) {
		this.selectedCreative = undefined;
		this.modalService.close(id);
	}

	requestData() {
		this.showLoad = true;
		this.hasData = true;
		this.socialCreative = this.sectiontitle.indexOf('Social') !== -1;
		this.analyticsService.processCustomServiceRequest(this.key).subscribe((response: any) => {
			this.showLoad = false;
			if (response.success) {
				this.hasData = true;
				this.responseData = response.data;
				this.processResponseData(response.data);
			} else {
				this.hasData = false;
			}
		});
	}

	generateColumGraphData(graphData) {
		graphData['stepCount'] = 14;
		graphData['columnBorders'] = true;
		let categories = [];
		for (let i = 0; i < graphData.categories.length; i++) {
			categories.push({
				value: '',
				date: graphData.categories[i]
			});
		}
		for (let i = 0; i < graphData.series.length; i++) {
			let data = [];
			for (let j = 0; j < graphData.categories.length; j++) {
				data.push(graphData.series[i].data[j]);
			}
			graphData.series[i].data = data;
		}
		this.generatePlotLines(categories);
		this.graphData.categories = this.generatePlotLines(categories).categories;
		this.graphData.plotLines = this.generatePlotLines(categories).plotLines;
		this.graphData.plotOptions = {
			series: {
				pointWidth: 6,
				groupPadding: 0.1,
				borderWidth: 0,
				states: {
					inactive: {
						opacity: 1
					}
				}
			},
			column: {
				stacking: null
			}
		};
	}

	generatePlotLines(categories) {
		let plotLines = [];
		let lineObj = {
			color: '#e7e7e7',
			dashStyle: 'ShortDash',
			value: 0,
			width: 1,
			label: {
				enabled: false
			}
		};
		categories = categories.map((val, index) => {
			lineObj.value = index - 0.5;
			plotLines.push(JSON.parse(JSON.stringify(lineObj)));
			return val;
		});
		return { categories: categories, plotLines: plotLines };
	}

	processSelectedLegendItem(legendItem) {
		this.selectedLegend = legendItem;
		for (const legendObj of this.legend) {
			legendObj.selected = false;
		}

		const selectedLegend: any = _.findWhere(this.legend, { value: legendItem.value });
		selectedLegend.selected = true;
		this.graphData = this.generateGraphDataBySelection(this.selectedLegend.value);
		this.generateColumGraphData(this.graphData);
	}

	getGraphsData(selectionItem) {
		const sortedCreatives = this.sortCreativesBySelection(selectionItem);
		let ad_ids = [];
		sortedCreatives.forEach((item) => {
			if (!item.creativeStats) ad_ids.push(item['ad_id']);
		});
		if (ad_ids.length > 0) {
			this.analyticsService
				.processCustomServiceRequest(this.tertiarykey, null, null, null, ad_ids)
				.subscribe((response: any) => {
					this.showLoad = true;
					if (response.success) {
						let count = 0;
						this.showLoad = false;
						this.creatives.forEach((item) => {
							let id = ad_ids.find((id) => id == item['ad_id']);
							if (id) {
								count += 1;
								item.creativeStats = this.mapResponseToCreativeStats(response.data[id]['creatives_by_date']);
								item.graphData = this.generateGraphDataByCreative(item.creativeStats);
							}
							if (count == ad_ids.length) {
								this.graphData = this.generateGraphDataBySelection(selectionItem);
								this.generateColumGraphData(this.graphData);
								this.hasData = true;
								this.hasGraphData = true;
								return this.graphData;
							}
						});
					}
				});
		}
	}

	processResponseData(responseData) {
		if (responseData.length > 0) {
			this.creatives = this.mapResponseDataToInterface(responseData);
			const videoCreatives = _.where(this.creatives, { isVideoCreative: true });
			this.isVideoCreative = videoCreatives.length > 0;
			const audioCreatives = _.where(this.creatives, { isAudioCreative: true });
			this.isAudioCreative = audioCreatives.length > 0;
			this.selectedLegend = _.findWhere(this.legend, { selected: true });
			this.sortedCreatives =
				this.sortdataby && !(this.sortdataby === 'undefined')
					? this.sortCreativesBySelection(this.sortdataby)
					: this.creatives.splice(0, this.showOnly);
			this.graphData = this.isOverviewSem
				? this.getGraphsData(this.selectedLegend.value)
				: this.generateGraphDataBySelection(this.selectedLegend.value);
			if (this.graphData) {
				this.generateColumGraphData(this.graphData);
				this.hasData = true;
				this.hasGraphData = true;
			}
		} else {
			this.hasData = false;
			this.creatives = [];
			this.sortedCreatives = [];
			this.graphData = {};
			this.selectedLegend = {};
		}
		const dateSet = {
			startDate: this.analyticsDataModel.startDate,
			endDate: this.analyticsDataModel.endDate,
			depricatedDate: this.analyticsDataModel.depricatedDate,
			goLiveDate: this.analyticsDataModel.goLiveDate
		};
		this.visibleDisplayStats = this.checkForVisibilityPermissions(this.displayStats, dateSet);
	}

	sortCreativesBySelection(selectionItem) {
		const sortedCreatives = _.sortBy(this.creatives, selectionItem).reverse();
		return sortedCreatives.splice(0, this.showOnly);
	}

	protected generateGraphDataBySelection(selectionItem) {
		const sortedCreatives = JSON.parse(JSON.stringify(this.sortedCreatives));
		const series = [];
		let length = sortedCreatives.length;
		for (let i = 0; i < sortedCreatives.length; i++) {
			const seriesObj: any = {};
			seriesObj['name'] = sortedCreatives[i].creativeName;
			seriesObj['data'] = sortedCreatives[i].graphData[selectionItem];
			seriesObj['color'] = this.colorArray[i];
			series.push(seriesObj);
			length--;
		}
		const categories = sortedCreatives.length > 0 ? sortedCreatives[0].graphData.dates : [];

		const graphData = { series: series, categories: categories };
		return graphData;
	}

	// changes for Video creatives start hear
	isActiveSlide(index) {
		return this.selectedIndex == index;
	}

	playclickEvent(event) {
		event.stopPropagation();
		jQuery('#' + this.playBtn).hide();
		jQuery('#' + this.pauseBtn).show();
		jQuery('#' + this.playTxt).hide();
		jQuery('#' + this.pauseTxt).show();
		jQuery(this.videoplayer.nativeElement)[0].play();
	}

	pauseclickEvent(event) {
		event.stopPropagation();
		jQuery('#' + this.playBtn).show();
		jQuery('#' + this.pauseBtn).hide();
		jQuery('#' + this.playTxt).show();
		jQuery('#' + this.pauseTxt).hide();
		jQuery(this.videoplayer.nativeElement)[0].pause();
	}

	slideClicked(index) {
		this.selectedIndex = index;
		this.cdr.detectChanges();
		this.isMuted = true;
		this.controlsOptions();
		if (jQuery('#' + this.sectionclass)[0] != undefined) {
			jQuery('#' + this.sectionclass)[0].muted = true;
		}
		this.carousel.slideClicked(index);
		for (let slide in this.carousel.$slides) {
			this.carousel.$slides[slide].className = 'carouselSlide ' + this.sectionclass;
		}
		this.carousel.$slides[index].className = 'carouselSlideActive ' + this.sectionclass + 'Active';
		jQuery('.carouselSlideActive .slide-3d .slideMask').css({
			width: '0px',
			height: '0px'
		});
		jQuery(' .carouselSlideActive .slide-3d').css({
			'margin-top': '0% !important'
		});
		jQuery(' .carouselSlide .slide-3d').css({
			'margin-top': '0% !important'
		});
		jQuery('.carouselSlide .slide-3d .slideMask').css({
			width: '100%',
			height: '100%'
		});
		jQuery('.carouselSlide .volumeControls').css({
			visibility: 'hidden !important'
		});

		jQuery('.stats-div').css({
			height: '100%',
			width: '100%'
		});
		if (this.analyticsDataModel.getCurrentPath() === PATHS.OVERVIEW) {
			if (this.socialCreative) {
				jQuery('.ovw_r5_socialActive .display_creative_img').css({
					height: '290px'
				});
			}
		}
		this.selectedIndex = index;
		this.currentCreativeData = JSON.parse(JSON.stringify(this.sortedCreatives[this.selectedIndex]));
		const pickedData = _.pick(this.sortedCreatives[this.selectedIndex], this.visibleDisplayStats);
		let keys = [];
		this.currentStats = _.map(this.legend, (legend, index) => {
			if (pickedData[legend['value']]) {
				let hasPercent = legend['value'].slice(0, -1) + 'Rate' in pickedData;
				let percent_value = hasPercent
					? numeral(pickedData[legend['value'].slice(0, -1) + 'Rate']).format('0,0.00') + '%'
					: '';
				return {
					name: legend['displayName'],
					value: Number(pickedData[legend['value']]),
					hasPercent: hasPercent,
					percent_value: percent_value
				};
			} else {
				return {
					name: legend['displayName'],
					value: ''
				};
			}
		});
		for (let key in pickedData) {
			if (
				key.toLowerCase().includes('rate') ||
				key.toLowerCase() == 'absolutetopimpression' ||
				key.toLowerCase() == 'topimpression'
			) {
				this.currentCreativeData[key] = numeral(this.currentCreativeData[key]).format('0,0.00') + '%';
			} else {
				this.currentCreativeData[key] = this.currentCreativeData[key].toLocaleString();
			}
			if (key.startsWith('avg')) {
				keys.push({
					name: 'Avg. ' + key.charAt(3).toUpperCase() + key.substr(4, key.length) + '',
					value: this.currentCreativeData[key]
				});
			} else {
				keys.push({ name: key.replace(/([A-Z])/g, ' $1').trim(), value: this.currentCreativeData[key] });
			}
		}
		this.currentCreativeStats = keys;
	}

	volumeclick(event) {
		event.stopPropagation();
		this.isMuted = true;
		jQuery('#' + this.sectionclass)[0].muted = true;
	}

	muteclick(event) {
		event.stopPropagation();
		this.isMuted = false;
		jQuery('#' + this.sectionclass)[0].muted = false;
	}

	// changes for Video creatives end hear

	ngAfterViewInit() {
		super.ngAfterViewInit();
	}

	ngAfterViewChecked() {
		super.ngAfterViewChecked();
	}

	ngAfterContentChecked() {
		jQuery('.inline' + this.visibleDisplayStats.length).css('width', 100 / this.visibleDisplayStats.length + '%');

		jQuery('.slide-3d').css({
			'border-color': 'rgba(0, 0, 0, 0.5)',
			'border-width': '1px',
			'border-style': 'none'
		});
		jQuery('.carousel-3d-container').css({
			height: '350px'
		});

		// super.ngAfterContentChecked();
	}

	ngOnDestroy() {
		super.ngOnDestroy();
		this.selectedCreative = undefined;
	}

	checkForVisibilityPermissions(items, dateSet) {
		const { startDate, endDate, depricatedDate, goLiveDate } = dateSet;
		const isGoliveNotStarted = moment(endDate).isBefore(goLiveDate);
		const isCutoffDate = moment(startDate).isAfter(depricatedDate) || moment(startDate).isSame(depricatedDate);
		const avgPositionFilterText = ['avg_position', 'avgPosition', 'Avg. Position'];
		const newImpressionsFilterText = ['absoluteTopImpression', 'TopImpression', 'topImpression'];

		if (isGoliveNotStarted) {
			items = items.filter((item) => !newImpressionsFilterText.includes(item));
		}
		if (isCutoffDate) {
			items = items.filter((item) => !avgPositionFilterText.includes(item));
		}
		return items;
	}

	controlsOptions() {
		let self = this;
		const media = document.getElementById(self.sectionclass);

		let gettheVideoTotalDuration;

		const isPlaying = function (e) {
			if (jQuery('#' + self.sectionclass)[0] != undefined) {
				gettheVideoTotalDuration = jQuery('#' + self.sectionclass)[0].duration;
			}

			jQuery('#' + self.pauseBtn).show();
			jQuery('#' + self.playBtn).hide();
			jQuery('#' + self.pauseTxt).show();
			jQuery('#' + self.playTxt).hide();
		};
		const onPause = function (e) {
			if (
				jQuery('#' + self.sectionclass)[0] &&
				jQuery('#' + self.sectionclass)[0].currentTime === gettheVideoTotalDuration
			) {
				jQuery('#' + self.pauseBtn).hide();
				jQuery('#' + self.playBtn).show();
				jQuery('#' + self.pauseTxt).hide();
				jQuery('#' + self.playTxt).show();
			}
		};
		const onTimeUpdate = function (e) {
			if (
				jQuery('#' + self.sectionclass)[0] &&
				jQuery('#' + self.sectionclass)[0].currentTime >= gettheVideoTotalDuration
			) {
				jQuery('#' + self.playBtn).show();
				jQuery('#' + self.pauseBtn).hide();
				jQuery('#' + self.playTxt).show();
				jQuery('#' + self.pauseTxt).hide();
			}
		};
		if (media) {
			media.addEventListener('playing', isPlaying, false);
			media.addEventListener('pause', onPause, false);
			media.addEventListener('timeupdate', onTimeUpdate, false);
		}
	}

	mapResponseDataToInterface(responseData: any): CreativePerformance[] {
		let creativePerformances: CreativePerformance[] = [];
		for (const response of responseData) {
			const creativeObj: any = {};
			let location = '';
			const siteLinksArr = [];
			const structuredSnippetExtnArr = [];
			const calloutsExtnArr = [];
			let locationObj = {};
			let siteLinks = [];
			let structuredSnippetExtn = [];
			let calloutsExtn = [];
			creativeObj.creativeName = response.creative_name
				? response.creative_name
				: response.name
				? response.name
				: response.ad_headline;
			creativeObj.ad_title = UtilityService.isUndefinedOrNull(response.ad_title)
				? ''
				: response.ad_title == ''
				? ''
				: response.ad_title;
			creativeObj.versionId = UtilityService.isUndefinedOrNull(response.cup_version_id)
				? 0
				: parseFloat(response.cup_version_id);
			creativeObj.clicks = UtilityService.isUndefinedOrNull(response.clicks) ? 0 : parseFloat(response.clicks);
			creativeObj.youtubeviews = UtilityService.isUndefinedOrNull(response.youtubeviews)
				? UtilityService.isUndefinedOrNull(response['youtube_verified_imprs'])
					? 0
					: parseFloat(response['youtube_verified_imprs'])
				: parseFloat(response.youtubeviews);
			creativeObj.youtubeviewRate = UtilityService.isUndefinedOrNull(response.youtubeview_rate)
				? UtilityService.isUndefinedOrNull(response['youtube_verified_imprs_rate'])
					? 0
					: parseFloat(response['youtube_verified_imprs_rate'])
				: parseFloat(response.youtubeview_rate);

			creativeObj.adInteractions = UtilityService.isUndefinedOrNull(response.ad_interactions)
				? 0
				: parseFloat(response.ad_interactions);
			creativeObj.adInteractionRate = UtilityService.isUndefinedOrNull(response.interaction_rate)
				? 0
				: parseFloat(response.interaction_rate);
			creativeObj.impressions = UtilityService.isUndefinedOrNull(response.impressions)
				? 0
				: parseFloat(response.impressions);
			creativeObj.clickRate = UtilityService.isUndefinedOrNull(response.click_rate)
				? UtilityService.isUndefinedOrNull(response.clickthroughrate)
					? creativeObj.impressions > 0
						? ((creativeObj.clicks / creativeObj.impressions) * 100).toFixed(2)
						: 0
					: parseFloat(response.clickthroughrate)
				: parseFloat(response.click_rate);
			creativeObj.individualImpressions = response.individual_impressions
				? parseFloat(response.individual_impressions)
				: null;
			creativeObj.isCtv =
				this.sectiontitle.indexOf('TV Everywhere Creatives') !== -1 ||
				this.sectiontitle.indexOf('Connected TV Creatives') !== -1 ||
				this.sectiontitle.indexOf('CTV/OTT Creatives') !== -1 ||
				this.analyticsDataModel.getCurrentPath() === PATHS.CTV;
			creativeObj.isDisplay =
				this.sectiontitle.indexOf('Display') !== -1 || this.analyticsDataModel.getCurrentPath() === PATHS.DISPLAY;
			creativeObj.isSocial =
				this.sectiontitle.indexOf('Social') !== -1 || this.analyticsDataModel.getCurrentPath() === PATHS.SOCIAL;
			creativeObj.isPreRoll =
				this.sectiontitle.indexOf('Video Creatives') !== -1 ||
				this.sectiontitle.indexOf('Pre Roll Creatives') !== -1 ||
				this.analyticsDataModel.getCurrentPath() === PATHS.PREROLL;
			creativeObj.isRadio =
				this.sectiontitle.indexOf('Audio') !== -1 || this.analyticsDataModel.getCurrentPath() === PATHS.RADIO;
			creativeObj.callExtension = response && response.call_extn ? JSON.parse(response.call_extn)[0][1] : '';
			if (response.location_extn) {
				try {
					locationObj = JSON.parse(response.location_extn)[0];
				} catch (e) {
					locationObj = {};
				}
				const locationArr = [];
				for (const prop in locationObj) {
					if (parseInt(prop, 10) > 1 && parseInt(prop, 10) < 8) {
						locationArr.push(locationObj[prop]);
					}
				}
				location = locationArr.join(', ');
				creativeObj.location = location;
			}

			if (response.url) {
				try {
					creativeObj.url = typeof response.url == 'string' ? response.url : JSON.parse(response.url)[0];
				} catch (error) {
					creativeObj.url = response.url;
				}
			}
			creativeObj.adHeadline = UtilityService.isUndefinedOrNull(response.ad_headline) ? '' : response.ad_headline;
			creativeObj.clickthroughrate = UtilityService.isUndefinedOrNull(response.clickthroughrate)
				? 0
				: parseFloat(response.clickthroughrate);
			creativeObj.impressions = parseFloat(response.impressions);
			creativeObj.avgPosition = response.avg_position;
			creativeObj.absTopImpression = response.abs_top_impression_share;
			creativeObj.adgroup_name = UtilityService.isUndefinedOrNull(response.adgroup_name) ? '' : response.adgroup_name;
			creativeObj.adgroup_id = UtilityService.isUndefinedOrNull(response.adgroup_id) ? '' : response.adgroup_id;
			creativeObj.ad_id = UtilityService.isUndefinedOrNull(response.ad_id) ? '' : response.ad_id;
			creativeObj.ad_type = UtilityService.isUndefinedOrNull(response.ad_type) ? '' : response.ad_type;
			creativeObj.final_url = UtilityService.isUndefinedOrNull(response.creative_final_urls)
				? ''
				: response.creative_final_urls;
			creativeObj.ad_description = UtilityService.isUndefinedOrNull(response.ad_description)
				? ''
				: response.ad_description;
			creativeObj.top_impression_share = parseFloat(response.top_impression_share);
			creativeObj.abs_top_impression_share = parseFloat(response.abs_top_impression_share);
			creativeObj.topImpressionShare = parseFloat(response.top_impression_share).toFixed(2);
			creativeObj.absTopImpressionShare = parseFloat(response.abs_top_impression_share).toFixed(2);
			creativeObj.absoluteTopImpression = parseFloat(response.abs_top_impression_share);
			creativeObj.topImpression = response.top_impression_share;
			creativeObj.description = UtilityService.isUndefinedOrNull(response.description) ? '' : response.description;
			const temCreativeDesc = creativeObj.description.split('|');
			if (temCreativeDesc.length > 1) {
				creativeObj.description = temCreativeDesc;
			}
			if (response.sitelink_extn) {
				try {
					siteLinks = JSON.parse(response.sitelink_extn);
				} catch (e) {
					siteLinks = [];
				}
				for (const item of siteLinks) {
					siteLinksArr.push({
						// tslint:disable-next-line: prefer-template
						description: (item['3'] || '') + ' ' + (item['4'] || ''),
						heading: item['1'],
						link: Array.isArray(item['5']) ? item['5'][0] : item['5']
					});
				}
			}
			if (response.structuredsnippet_extn) {
				structuredSnippetExtn = JSON.parse(response.structuredsnippet_extn);
				for (const item of structuredSnippetExtn) {
					structuredSnippetExtnArr.push({
						type: item['1'],
						value: !UtilityService.isUndefinedOrNull(item['2']) || item['2'] !== '' ? item['2'].join(', ') : item['2']
					});
				}
			}
			if (response.callouts_extn) {
				calloutsExtn = JSON.parse(response.callouts_extn);
				for (const item of calloutsExtn) {
					calloutsExtnArr.push(item['1']);
				}
			}

			creativeObj.percentRate25 =
				this.isR5 && response['25_percent_rate_with_start_count']
					? response['25_percent_rate_with_start_count']
					: response['25_percent_rate'];
			creativeObj.percentValue25 = response['25_percent_value'];
			creativeObj.percentRate50 =
				this.isR5 && response['50_percent_rate_with_start_count']
					? response['50_percent_rate_with_start_count']
					: response['50_percent_rate'];
			creativeObj.percentValue50 = response['50_percent_value'];
			creativeObj.percentRate75 =
				this.isR5 && response['75_percent_rate_with_start_count']
					? response['75_percent_rate_with_start_count']
					: response['75_percent_rate'];
			creativeObj.percentValue75 = response['75_percent_value'];
			creativeObj.percentRate100 =
				this.isR5 && response['100_percent_rate_with_start_count']
					? response['100_percent_rate_with_start_count']
					: response['100_percent_rate'];
			creativeObj.percentValue100 = response['100_percent_value'];

			creativeObj.isIAB = UtilityService.isUndefinedOrNull(response.isIAB)
				? false
				: Number(response.isIAB)
				? true
				: false;
			creativeObj.isNative = UtilityService.isUndefinedOrNull(response.isNative)
				? false
				: Number(response.isNative)
				? true
				: false;
			creativeObj.native = response.native;
			creativeObj.startCount = response.start_count ? response.start_count : null;
			creativeObj.isVideoCreative =
				(!UtilityService.isUndefinedOrNull(response.video_url) ||
					!UtilityService.isUndefinedOrNull(response.media_files) ||
					creativeObj.isPreRoll) &&
				!creativeObj.isSocial;
			creativeObj.isAudioCreative = !UtilityService.isUndefinedOrNull(response.audio_url);
			creativeObj.creativeThumbnail = UtilityService.isUndefinedOrNull(response.creative_thumbnail_image)
				? this.placeholderimage
				: UtilityService.checkEncodeURI(response.creative_thumbnail_image)
				? response.creative_thumbnail_image
				: encodeURI(response.creative_thumbnail_image);
			creativeObj.hasSnapshotImage = !UtilityService.isUndefinedOrNull(response.snapshot_path);
			creativeObj.iframeUrl = UtilityService.isUndefinedOrNull(response.iframe_url) ? null : response.iframe_url;
			creativeObj.isIframeExpired = response.is_iframe_expired === 0 ? false : true;
			creativeObj.snapshotImage = response.snapshot_path;
			if (creativeObj.isVideoCreative) {
				creativeObj.creativeThumbnail = response.thumbnail ? response.thumbnail : response.creative_thumbnail_image;
				creativeObj.creativeVideo = !UtilityService.isUndefinedOrNull(response.video_url)
					? response.video_url
					: response.media_files;
			}
			if (creativeObj.isAudioCreative) {
				creativeObj.audioURL = response.audio_url ? response.audio_url : null;
			}
			if (this.isR5) {
				creativeObj.completionRate = UtilityService.isUndefinedOrNull(response['100_percent_rate_with_start_count'])
					? UtilityService.isUndefinedOrNull(response['100_percent_rate_with_start_count'])
						? UtilityService.isUndefinedOrNull(response.completion_rate)
							? UtilityService.isUndefinedOrNull(response['100_percent_rate'])
								? 0
								: parseFloat(response['100_percent_rate']).toFixed(2)
							: parseFloat(response.completion_rate).toFixed(2)
						: parseFloat(response['100_percent_rate_with_start_count']).toFixed(2)
					: parseFloat(response['100_percent_rate_with_start_count']).toFixed(2);
			} else {
				creativeObj.completionRate = UtilityService.isUndefinedOrNull(response.completion_rate)
					? UtilityService.isUndefinedOrNull(response['100_percent_rate'])
						? 0
						: parseFloat(response['100_percent_rate']).toFixed(2)
					: parseFloat(response.completion_rate).toFixed(2);
			}
			creativeObj.completions = UtilityService.isUndefinedOrNull(response.completion_value)
				? UtilityService.isUndefinedOrNull(response['100_percent_value'])
					? 0
					: parseInt(response['100_percent_value'], 10)
				: parseInt(response.completion_value, 10);
			if (response.creatives_by_ads) {
				creativeObj.adSizes = !creativeObj.isVideoCreative
					? this.mapResponseToAdSizes(response.creatives_by_ads ? response.creatives_by_ads : [])
					: ({} as { string: CreativeAdSize });
				creativeObj.hasAdSizes = !creativeObj.isVideoCreative ? !!response.creatives_by_ads : false;
			}
			if (response.creatives_by_date) {
				creativeObj.creativeStats = this.mapResponseToCreativeStats(response.creatives_by_date);
			}
			creativeObj.graphData = this.generateGraphDataByCreative(creativeObj.creativeStats);
			if (creativeObj.isSocial) {
				if (creativeObj.percentRate25 > 0) {
					creativeObj.creativeThumbnail = creativeObj.isIframeExpired
						? creativeObj.hasSnapshotImage
							? response.snapshot_path
							: ''
						: creativeObj.creativeThumbnail;
					creativeObj.isVideoCreative = false;
					if (this.analyticsDataModel.getCurrentPath() === PATHS.SOCIAL) {
						creativeObj.showStats = true;
					}
				} else {
					creativeObj.isVideoCreative = false;
					creativeObj.showStats = false;
					creativeObj.creativeThumbnail = creativeObj.isIframeExpired
						? creativeObj.hasSnapshotImage
							? response.snapshot_path
							: ''
						: creativeObj.creativeThumbnail;
				}
			}
			creativeObj.engagementDetails = this.mapEngagementDetails(response);
			creativeObj.engagements = response.engagements ? response.engagements : null;

			if (response.callouts_extn_attribute_values) {
				calloutsExtn = JSON.parse(response.callouts_extn_attribute_values);
				for (const item of calloutsExtn) {
					calloutsExtnArr.push(item['1']);
				}
			}

			if (response.structuredsnippet_extn_attribute_values) {
				structuredSnippetExtn = JSON.parse(response.structuredsnippet_extn_attribute_values);
				for (const item of structuredSnippetExtn) {
					structuredSnippetExtnArr.push({
						type: item['1'],
						value: !UtilityService.isUndefinedOrNull(item['2']) || item['2'] != '' ? item['2'].join(', ') : item['2']
					});
				}
			}

			siteLinks =
				!UtilityService.isUndefinedOrNull(response.sitelink_extn_attribute_values) &&
				response.sitelink_extn_attribute_values !== ''
					? JSON.parse(response.sitelink_extn_attribute_values)
					: [];

			for (const item of siteLinks) {
				siteLinksArr.push({
					heading: item['1'] || '',
					description: (item['3'] || '') + ' ' + (item['4'] || ''),
					link: item['5'][0] || ''
				});
			}

			locationObj =
				!UtilityService.isUndefinedOrNull(response.location_extn_attribute_values) &&
				response.location_extn_attribute_values !== ''
					? JSON.parse(response.location_extn_attribute_values.replaceAll('\\"', '"'))[0]
					: {};
			let locationArr = [];
			for (let prop in locationObj) {
				if (parseInt(prop) > 1 && parseInt(prop) < 8) {
					locationArr.push(locationObj[prop]);
				}
			}
			location = locationArr.join(', ');
			creativeObj.location = location;

			creativeObj.calloutsExtn = calloutsExtnArr.length > 0 ? calloutsExtnArr : [];
			creativeObj.structuredSnippetExtn = structuredSnippetExtnArr;
			creativeObj.siteLinks = siteLinksArr;

			creativeObj.responsiveAdTitle = !UtilityService.isUndefinedOrNull(response.responsive_ad_title)
				? JSON.parse(response.responsive_ad_title)
				: [];
			creativeObj.responsiveAdDescription = !UtilityService.isUndefinedOrNull(response.responsive_ad_title)
				? JSON.parse(response.responsive_ad_title)
				: [];

			if (creativeObj.ad_type == 'RESPONSIVE_SEARCH_AD') {
				creativeObj.description = [];
				creativeObj.adHeadline =
					creativeObj.responsiveAdTitle.length > 1
						? creativeObj.responsiveAdTitle[0]['text'] +
						  ' + ' +
						  (creativeObj.responsiveAdTitle.length - 1) +
						  ' more headlines'
						: creativeObj.responsiveAdTitle.length == 1
						? creativeObj.responsiveAdTitle[0]['text']
						: '';
				creativeObj.responsiveAdDescription.forEach((item) => creativeObj.description.push(item['text']));
				creativeObj.url = UtilityService.isUndefinedOrNull(response.scaa_creative_final_urls)
					? UtilityService.isUndefinedOrNull(response.creative_final_urls)
						? ''
						: response.creative_final_urls
					: response.scaa_creative_final_urls;
				creativeObj.callExtension =
					response && response.call_extn_attribute_values
						? JSON.parse(response.call_extn_attribute_values.replaceAll('\\"', '"'))[0][1]
						: '';
			} else if (creativeObj.ad_type.toUpperCase().includes('DYNAMIC')) {
				creativeObj.description = [];
				creativeObj.adHeadline = 'Dynamically generated headline';
				let descpt1 = response.scaa_description1
					? response.scaa_description1.substring(0, 90)
					: response.description1
					? response.description1.substring(0, 90)
					: '';
				let descpt2 = response.scaa_description2
					? response.scaa_description2.substring(0, 90)
					: response.description2
					? response.description2.substring(0, 90)
					: '';
				creativeObj.description.push(descpt1, descpt2);
				creativeObj.url = 'Dynamically generated display URL';
				creativeObj.callExtension =
					response && response.call_extn_attribute_values
						? JSON.parse(response.call_extn_attribute_values.replaceAll('\\"', '"'))[0][1]
						: '';
			} else if (creativeObj.ad_type.toUpperCase().includes('CALL_ONLY_AD')) {
				creativeObj.description = [];
				creativeObj.adHeadline = response.scaa_headline
					? response.scaa_headline.substring(0, 30)
					: response.headline
					? response.headline.substring(0, 30)
					: '';
				let descpt1 = response.scaa_description1
					? response.scaa_description1.substring(0, 90)
					: response.description1
					? response.description1.substring(0, 90)
					: '';
				let descpt2 = response.scaa_description2
					? response.scaa_description2.substring(0, 90)
					: response.description2
					? response.description2.substring(0, 90)
					: '';
				creativeObj.description.push(descpt1, descpt2);
				creativeObj.url = UtilityService.isUndefinedOrNull(response.scaa_display_url)
					? UtilityService.isUndefinedOrNull(response.display_url)
						? ''
						: response.display_url
					: response.scaa_display_url;
				creativeObj.callExtension =
					response && response.call_extn_attribute_values
						? JSON.parse(response.call_extn_attribute_values.replaceAll('\\"', '"'))[0][1]
						: '';
			} else if (creativeObj.ad_type.length > 0) {
				let ad_headlines = [];
				creativeObj.description = [];
				ad_headlines.push(
					response.scaa_headline_part1
						? response.scaa_headline_part1.substring(0, 30)
						: response.headline_part1
						? response.headline_part1.substring(0, 30)
						: ''
				);
				ad_headlines.push(
					response.scaa_headline_part2
						? response.scaa_headline_part2.substring(0, 30)
						: response.headline_part2
						? response.headline_part2.substring(0, 30)
						: ''
				);
				ad_headlines.push(
					response.scaa_headline_part3
						? response.scaa_headline_part3.substring(0, 30)
						: response.headline_part3
						? response.headline_part3.substring(0, 30)
						: ''
				);
				creativeObj.adHeadline = ad_headlines.join(' | ');
				creativeObj.description.push(
					response.scaa_description
						? response.scaa_description.substring(0, 90)
						: response.description
						? response.description.substring(0, 90)
						: ''
				);
				creativeObj.url = UtilityService.isUndefinedOrNull(response.scaa_creative_final_urls)
					? UtilityService.isUndefinedOrNull(response.creative_final_urls)
						? ''
						: response.creative_final_urls
					: response.scaa_creative_final_urls;
				creativeObj.callExtension =
					response && response.call_extn_attribute_values
						? JSON.parse(response.call_extn_attribute_values.replaceAll('\\"', '"'))[0][1]
						: '';
			}

			creativePerformances.push(creativeObj);
		}
		let temp = [];

		if (this.isOverviewSem) {
			const formattedData = this.groupArrayOfObjectsByAdgroup(creativePerformances, 'adgroup_id');
			let adgroup_ids = Object.keys(formattedData);
			adgroup_ids.forEach((id, index) => {
				let eachAdgroup = formattedData[id];
				let ads = [];
				let combinations = [];
				eachAdgroup.forEach((element) => {
					if (element.ad_type != null && element.ad_type !== 'RESPONSIVE_SEARCH_AD' && element.ad_type !== '') {
						element.url = element.url
							? element.url.substring(
									element.url.indexOf('http') > -1
										? element.url.indexOf('http')
										: element.url.indexOf('www.') > -1
										? element.url.indexOf('www.')
										: 0,
									element.url.indexOf('"]')
							  )
							: '';
						ads.push(element);
					} else {
						if (element.ad_type == 'RESPONSIVE_SEARCH_AD') {
							element.url = element.url
								? element.url.substring(
										element.url.indexOf('http') > -1
											? element.url.indexOf('http')
											: element.url.indexOf('www.') > -1
											? element.url.indexOf('www.')
											: 0,
										element.url.indexOf('"]')
								  )
								: '';
							ads.push(element);
						}
					}
				});

				temp.push(...ads);
			});
			creativePerformances = temp;
		}
		return creativePerformances;
	}
	groupArrayOfObjectsByAdgroup(list, key) {
		return list.reduce(function (rv, x) {
			(rv[x[key]] = rv[x[key]] || []).push(x);
			return rv;
		}, {});
	}
}
